import React from 'react'

import Image from 'components/_new/ui/Image/Image'
import Box from 'components/_new/layout/Box/Box'

import s from './BirdImage.scss'

// resolve picture x2
import birdImage from './images/bird.png'


const ThankYouPageBirdImage = () => (
  <Box mt="36">
    <Image className={s.birdImage} fullWidth {...birdImage} />
  </Box>
)


export default ThankYouPageBirdImage
